(() => {
  'use strict';

  const ROOT_SELECTOR = '[data-gift-card-recipient]';

  class GiftCardRecipient {
    constructor(root) {
      this.root = root;
      this.checkbox = root.querySelector('[data-gift-card-recipient-checkbox]');
      this.fieldsWrap = root.querySelector('[data-gift-card-recipient-fields]');
      this.emailInput = root.querySelector('[data-gift-card-recipient-email]');
      this.messageInput = root.querySelector('[data-gift-card-recipient-message]');
      this.charCount = root.querySelector('[data-gift-card-recipient-char-count]');

      this._onToggle = this._onToggle.bind(this);
      this._onMessageInput = this._onMessageInput.bind(this);
    }

    init() {
      if (!this.checkbox || !this.fieldsWrap) return;

      this.checkbox.addEventListener('change', this._onToggle);
      this._sync();

      if (this.messageInput) {
        this.messageInput.addEventListener('input', this._onMessageInput);
        this._syncCharCount();
      }
    }

    _onToggle() {
      this._sync();
    }

    _sync() {
      const isChecked = this.checkbox.checked;
      this.fieldsWrap.hidden = !isChecked;

      this.fieldsWrap.querySelectorAll('input, textarea').forEach((field) => {
        field.disabled = !isChecked;
      });

      if (this.emailInput) {
        this.emailInput.required = isChecked;
      }
    }

    _onMessageInput() {
      this._syncCharCount();
    }

    _syncCharCount() {
      if (!this.charCount) return;
      const max = Number.parseInt(this.messageInput.getAttribute('maxlength'), 10) || 0;
      const current = this.messageInput.value.length;
      this.charCount.textContent = `${current}/${max}`;
    }
  }

  const instances = new Map();

  const init = (scope) => {
    const root = scope instanceof Element ? scope : document;
    root.querySelectorAll(ROOT_SELECTOR).forEach((node) => {
      if (instances.has(node)) return;
      const instance = new GiftCardRecipient(node);
      instance.init();
      instances.set(node, instance);
    });
  };

  const destroyIn = (scope) => {
    if (!(scope instanceof Element)) return;
    scope.querySelectorAll(ROOT_SELECTOR).forEach((node) => {
      instances.delete(node);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroyIn(event.target);
  });
})();
